import {
  DEFAULT_SOCIAL_METADATA,
  OPEN_GRAPH_IMAGE_HEIGHT,
  OPEN_GRAPH_IMAGE_WIDTH,
  type SocialMetadata,
} from "./social-metadata";

export type SocialHeadMetaTag =
  | { title: string }
  | { content: string; name: string }
  | { content: string; property: string };

function readClientStringEnv(value: string | boolean | undefined): string {
  return typeof value === "string" ? value.trim() : "";
}

function getConfiguredOpenGraphImageUrl(imagePath: string): string {
  const platformApiBaseUrl = readClientStringEnv(
    import.meta.env.VITE_PLATFORM_API_URL,
  );
  if (platformApiBaseUrl) {
    return `${platformApiBaseUrl.replace(/\/+$/u, "")}${imagePath}`;
  }

  if (imagePath === DEFAULT_SOCIAL_METADATA.imagePath) {
    const configuredDefaultUrl = readClientStringEnv(
      import.meta.env.VITE_OPEN_GRAPH_IMAGE_URL,
    );
    return configuredDefaultUrl || imagePath;
  }

  return imagePath;
}

export function createSocialHeadMeta(
  metadata: SocialMetadata,
): SocialHeadMetaTag[] {
  const imageUrl = getConfiguredOpenGraphImageUrl(metadata.imagePath);

  return [
    { title: metadata.title },
    { content: metadata.documentDescription, name: "description" },
    { content: metadata.title, property: "og:title" },
    { content: metadata.description, property: "og:description" },
    { content: "website", property: "og:type" },
    { content: imageUrl, property: "og:image" },
    { content: OPEN_GRAPH_IMAGE_WIDTH, property: "og:image:width" },
    { content: OPEN_GRAPH_IMAGE_HEIGHT, property: "og:image:height" },
    { content: "summary_large_image", name: "twitter:card" },
    { content: metadata.title, name: "twitter:title" },
    { content: metadata.description, name: "twitter:description" },
    { content: imageUrl, name: "twitter:image" },
  ];
}
